export default __webpack_public_path__ + "static/media/about_icon3hover.eceb1848.svg";